import React from "react";
import clsx from "clsx";
import { Col, Container, Row, Table } from "react-bootstrap";
import { uniqueId } from "lodash";
// import PropTypes from "prop-types";
import styles from "./style/PayoutPage.module.css";

const payoutDataList = [
  {
    amount: 2525.1515,
    method: "Payoneer",
    processDate: "15 Mar 2020",
  },
  {
    amount: 1950.14,
    method: "Payoneer",
    processDate: "15 Mar 2021",
  },
  {
    amount: 19424.14,
    method: "Cash",
    processDate: "15 Otc 2021",
  },
  {
    amount: 45353.14,
    method: "Payoneer",
    processDate: "30 Mar 2021",
  },
];

const PayoutPage = () => {
  return (
    <Container className="p-5">
      <h5 className="mb-5">
        <i className="bi bi-wallet2 mr-2"></i>
        Payout
      </h5>
      <Row className="gy-5">
        <Col md={5} lg={4}>
          <div className={clsx(styles.boxContainer)}>
            <div className={clsx("px-4 py-3", styles.title)}>
              <p className="m-0">Next payout</p>
            </div>
            <div className={clsx("p-3 pb-0", styles.content)}>
              <div className={styles.mainContent}>
                <strong className={styles.money}>$4568.50</strong>
                <div className={styles.viaPayoneer}>via Payoneer</div>
              </div>
              <div className={styles.footer}>
                Your payout will be processed on <strong>April 15, 2020</strong>
              </div>
            </div>
          </div>

          {/* <div className={clsx("mt-5", styles.boxContainer)}>
            <div className={clsx("px-4 py-3", styles.title)}>
              <p className="m-0">Payout account</p>
            </div>
            <div className={clsx("p-3 pb-0", styles.content)}>
              <div className={styles.mainContent}>
                <img
                  src="https://gambolthemes.net/html-items/cursus_main_demo/images/payoneer.svg"
                  alt=""
                />
                <div className="mt-2">
                  <strong>Added: </strong>
                  01 Mar 2020
                </div>
              </div>
              <div className={styles.footer}>
                <Button className="w-100">Set Account</Button>
              </div>
            </div>
          </div> */}
        </Col>

        <Col md={7} lg={8}>
          <Table className={styles.tablePayout} responsive>
            <thead>
              <tr>
                <th>Amount</th>
                <th>Payout Method</th>
                <th>Date Processed</th>
              </tr>
            </thead>
            <tbody>
              {payoutDataList.map((data) => {
                return (
                  <tr key={uniqueId()}>
                    <td>${data.amount.toFixed(2)}</td>
                    <td>{data.method}</td>
                    <td>{data.processDate}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
};

/* required: display name */
PayoutPage.displayName = "PayoutPage";

/* required: props types */
PayoutPage.propTypes = {};

/* required: default props */
PayoutPage.defaultProps = {};

export { PayoutPage };
